module.exports = __webpack_public_path__ + "img/course.fe5b7442.png";